import enLocale from "element-ui/lib/locale/lang/en";

export default {
  common: {
    success: "success",
    error: "error",
    fail: "failed",
    null: "null",
    reminder: "tip",
    notNull: "Can not be blank",
    formatInfo: "Please fill in the information as required",
    permissionWarning: "You are not allowed to do this",
    clickForMore: "click for more detail",
    download: "download",
    clickToCopy: "click to copy",
    copySuccess: "copied to the clipboard",
    emailFormat: "Please enter a valid email address",
    confirmTitle: "Confirmation",
    uploadLimit: "*Only {type} files can be uploaded, no larger than {size}M",
    uploadErrorMessage: "Failed to upload the file, please try again.",
    loading: "loading",
    submitting: "submitting, please wait a moment",
    saving: "saving",
  },
  table: {
    operation: "operation",
    team: "team",
    ratio: "score ratio",
    rules: "score rules",
    title: "title",
    class: "class",
    score: "score",
    type: "type",
    status: "status",
    submitted: "submitted",
    unsubmitted: "unsubmitted",
  },
  button: {
    add: "add",
    save: "save",
    cancel: "cancel",
    confirm: "OK",
    back: "back",
    look: "detail",
    join: "join",
    edit: "edit",
    upload: "upload",
  },
  filter: {
    noStart: "not start",
    doing: "in progress",
    marking: "marking",
    end: "end",
    null: "null",
    exam: "examination",
    exercise: "exercise",
    contest: "contest",
  },
  // loginPage.vue
  loginPage: {
    welcome: "Welcome to Mooctest",
    login: "login",
    register: "sign up",
    email: "email",
    inputEmail: "Please enter your email",
    password: "password",
    inputPsd: "Please enter your password",
    emailNotNull: "Email address is required",
    passwordNotNull: "Please enter a password",
    loginError: "The username or password is incorrect",
    manageEntrance: "Login as Teacher",
    forgetPassword: "forgot your password?",
    ForgetPassword: "Forget Password",
    sendEmailInfo:
      "A password reset email has been sent to {e}, please check it.",
    emailPlaceholder: "Please enter your primary Mooctest email address.",
    captcha: "captcha",
    changeOne: "Change one",
  },
  // loginPage.vue
  registerPage: {
    welcome: "Welcome to Mooctest",
    login: "login",
    register: "sign up",
    username: "username",
    inputRealName: "Please enter your real name",
    email: "email",
    inputEmail: "Please enter your email",
    password: "password",
    inputPsd: "Please enter your password",
    confirm: "confirm",
    inputPsdAgain: "Please enter the password again",
    psdLength: "Ensure the password contains {s} to {l} characters",
    nameLength: "Ensure the username contains {s} to {l} characters",
    psdDiffer: "The two entered passwords do not match",
    emailFormat: "Please enter a valid email address",
    userExist: "user already exists",
  },
  // Leftbar.vue
  leftBar: {
    compWebsite: "Competition official website",
    forum: "Mooctest Forum",
    tool: "Tool download",
    compEntrance: "Competition entrance",
    help: "User help",
    teacherAuth: "Become a teacher",
  },
  footer: {
    compWebsite: "Competition official website",
    compEntrance: "Competition entrance",
    compGuide: "Competition Guide",
  },
  narBar: {
    competition: "competition",
    home: "home",
    task: "task",
    class: "class",
    loginAndRegister: "login/sign up",
    account: "account",
    profile: "personal profile",
    logout: "log out",
  },
  // competitionInfo
  competitionInfo: {
    compInfo: "Competition Information",
    qq: "Official QQ Group",
    helpInfo: "Help Information",
    wx: "WeChat Official Account",
    manageEntrance: "Teacher Management System Entrance",
  },
  // competition/List
  competitionList: {
    compList: "Competition List",
    signUp: "sign up",
    quit: "quit",
    enter: "get into",
    stage: "current stage of competition",
    nextRound: "next round",
    nextRoundTrue: "You have qualified for the next round",
    nextRoundFalse: "Not yet qualified for the next round",
    mentor: "mentor(s)",
    teammate: "teammate(s)",
    emailFormat: "Please enter a valid email address",
    name: "username",
    email: "email",
    numberLimit: "You can add less than {n} user(s)",
    contestRule: "Competition Rules",
    teamInfoTip: "Team Information Consistent with Part 1",
    teamTip:
      "Note: Registering automatically makes you the team leader. Team members do not need to register; " +
      "they can be added by the team leader.",
    goToFill: "Go to Fill Out",
    part2tip:
      "Web testing competition consists of two parts: Part 1 includes one question each for functional " +
      "testing and performance testing, while Part 2 includes one question for functional testing. " +
      "Please make sure to complete the questions for both parts.",
    profileTip:
      "Please complete your profile before proceeding to register for the competition.",
    quitTip: "Are you sure you want to quit the competition?",
  },
  competitionDetail: {
    examInfo: "Examination Information",
    examName: "examination title",
    paperName: "paper information",
    time: "start-stop time",
    initiator: "initiator",
    examiner: "examiner",
    submitted: "submitted",
    requirement: "test requirement",
    description: "requirement description",
    key: "key",
  },
  // Task.vue
  task: {
    task: "My Task",
    putKeyword: "Please enter the search keyword",
  },
  // task/detail.vue
  taskDetail: {
    detail: "Task Detail",
    type: "task type",
    name: "task name",
    time: "start-stop time",
    initiator: "initiator",
    paperName: "paper name",
    creator: "creator",
    difficulty: "difficulty",
    description: "description",
    taskInfo: "infomation",
    document: "requirement document",
    problem: "problem statement",
    key: "key",
    file: "file",
    annexFile: "answer annex",
    downloadAnnex: "download annex",
    answerFile: "upload answer file",
    downloadSubmitAnswer: "download my answer",
    uploadAnswerLimit: "*Only .java files can be uploaded, no larger than 1M",
    upload: "upload",
    uploadAgain: "upload again",
    uploadLimit: "*Only xlsx/xls files can be uploaded",
    record: "record",
    totalScore: "total score",
    targetFile: " test target",
    developerNotice:
      "Note: The developer's answer submission method has been upgraded. " +
      "The Eclipse client and key have been removed. Click to learn more.",
    submitDocForWEB: "test case document",
    submitCodeForWEB: "test code",
    submitPackageForWEB: "screenshot compressed package",
  },
  // class/index.vue
  classList: {
    myClass: "My Class",
    joinClass: "join a class",
    joinClassL: "Join a class",
    class: "class",
    classId: "classId",
    inputId: "Please enter the class number",
    teacherName: "teacher",
    inputTeacher: "Please enter the teacher's username",
    joinError: "The teacher name or number is incorrect",
    allowJoinError: "This class is not allowed to join",
  },
  // class/detail.vue
  classDetail: {
    detail: "Class Detail",
    title: "class name",
    id: "class number",
    size: "class size",
  },
  // Profile
  profile: {
    profile: "Personal Profile",
    editProfile: "edit personal profile",
    editProfileL: "Edit Personal Profile",
    name: "username",
    identity: "identity",
    stuNumber: "student ID",
    tel: "mobile",
    email: "email",
    school: "school",
    location: "location",
    city: "city",
    mentor: "mentor",
    mentor_email: "mentor's email",
    attachment: "attachment",
    student: "student",
    teacher: "teacher",
    uploadLimit:
      "Only jpg/png files with a maximum size of 500kb can be uploaded",
    editPassword: "edit your password",
    password: "password",
    // edit
    editPasswordL: "Edit Password",
    newPsd: "new password",
    oldPsd: "old password",
    confirmPsd: "confirm password",
    newPsdNull: "Please enter password",
    oldPsdNull: "Please enter the old password",
    confirmPsdNull: "Please enter the password again",
    psdDiffer: "Two password entries differ",
    confirmRemove: "Confirm to remove the file",
    fileExceed: "You can only upload one file",
    nameLength: "Ensure the username contains {s} to {l} characters",
    toAdd: "None yet, to be added",
    competitionInfoTip:
      "Related to competition registration and certificate issuance, please fill in carefully.",
  },
  // 下载
  download: {
    downloadPage: "plugin download page",
    downloadAddress: "Download Address",
    plugin: "plugin",
    eclipse: "eclipse",
    maven: "Maven",
    address: "address",
    jdk: "jdk",
    eclipsePlugin: "eclipse plugin download",
    linuxEclipse: "Eclipse with plugin Download for Linux",
    macEclipse: "Eclipse with plugin Download for Mac",
    win64WithPluginEclpiseDownload: "win64 With Plugin Download For Eclpise",
    win64jdk: "win64 jdk1.8 download address",
    jmeter: "jmeter plugin download",
    embedded: "embedded testing tools",
  },
  pwdReset: {
    resetPassword: "Reset Your Password",
    manageEntrance: "login as a teacher",
    stuEntrance: "login as a student",
    successInfo:
      "You have successfully changed your password, go to the login page.",
  },
  requestError: {
    serverError: "Unable to connect to the server",
    loginTimeout:
      "Login timed out, please log in again. Redirecting to the login.",
    timeout: "Request timed out, please try again",
  },
  ...enLocale,
};
